import { TAG } from "../constants";
import { PatientRating, UpdatePatientRating } from "../types";
import { patientApi } from "./patientApi";

export const patientRatingsApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    updateRating: builder.mutation<PatientRating, UpdatePatientRating>({
      query: ({ id, ...rest }) => ({
        method: "PUT",
        url: `/api/patient/patient-ratings/${id}`,
        body: rest,
      }),
      invalidatesTags: [TAG.PATIENT_RATINGS, TAG.TASKS],
    }),
  }),
});

export const { useUpdateRatingMutation } = patientRatingsApi;
